import React, { useState } from 'react';
import MailIcon from './MailIcon';
import { EMAIL } from '../data/siteData';
import './MailCopyButton.css';

const MailCopyButton = () => {
  const [copied, setCopied] = useState(false);

  const copyEmail = () => {
    navigator.clipboard.writeText(EMAIL);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <button
      type="button"
      className="mail-copy-button"
      onClick={copyEmail}
      aria-label={`Copy email address ${EMAIL}`}
    >
      <MailIcon />
      <span className={`mail-copy-tooltip${copied ? ' mail-copy-tooltip--visible' : ''}`}>
        Copied!
      </span>
    </button>
  );
};

export default MailCopyButton;
